import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from 'components/ui/select';
import { PricingKind } from 'types/pricelists';
import { t } from 'utils/getTranslations';

interface Props {
    value: PricingKind;
    // The case's stored kind and the tenant's mode, the only kinds a case moves between.
    kinds: PricingKind[];
    onChange: (pricingKind: PricingKind) => void;
}

const KIND_LABEL: Record<PricingKind, string> = {
    [PricingKind.ROLE]: 'pricelists.case-follow.kind-role',
    [PricingKind.EMPLOYEE]: 'pricelists.case-follow.kind-employee',
};

/** How the case prices its work, offered only while the case's kind differs from the tenant's mode. */
export function PricingKindSwitch({ value, kinds, onChange }: Props): JSX.Element {
    const items = kinds.map((kind) => ({ value: kind, label: t(KIND_LABEL[kind]) }));
    return (
        <div className="flex items-center gap-2 text-[0.8rem]">
            <span className="text-grey-700 font-semibold">{t('pricelists.case-follow.kind-label')}</span>
            <Select<PricingKind>
                items={items}
                value={value}
                onValueChange={(next) => {
                    if (next !== null && next !== value) {
                        onChange(next);
                    }
                }}
            >
                <SelectTrigger
                    size="sm"
                    className="bg-paper w-40 text-xs"
                    aria-label={t('pricelists.case-follow.kind-label')}
                >
                    <SelectValue />
                </SelectTrigger>
                <SelectContent>
                    {items.map((item) => (
                        <SelectItem key={item.value} value={item.value}>
                            {item.label}
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>
        </div>
    );
}
